import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS, getValidRetryLines } from "../../../../constants/value";
import { __getChangeNumber } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "iccid",
  "status",
  "zipcode",
  "old_msisdn",
  "new_msisdn",
];

const ChangeNumberBatch = () => (
  <BatchDetail
    title="Change Number"
    apiGet={__getChangeNumber}
    client={CLIENTS.it}
    columnsFactory={(ctx) => changeNumberColumns({ ...ctx, showAreaZip: true })}
    copyKeys={COPY_KEYS}
    exportAction="change_number"
    retryOperation="change_number"
    showTerminate
    updateAndRetry={{ getValidRetryLines, path: "update" }}
    getRowPath={(row) => `/it/change_number/${row.id}`}
  />
);

export default ChangeNumberBatch;
